import React from 'react';
import ListMap from '../ListMap';
import request from 'arcdynamic-request';
import {PROPERTIES} from '../../consts/tables';
import { ApolloConsumer } from '@apollo/client';
import { GET_PROPERTY_DATA } from '../Graphql/Queries/propertiesQuery';
import { fetchData } from '../Service/graphQlService';

export default class PropertyMap extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			property: null,
		};
		this.client= null;
	}

	componentDidMount() {
		if(this.props.client){
		this.getProperty(this.props.params.id);
		}
	}

	getProperty(id) {
		// request(arc.path.api, {
		// 	service: 'arcimedes',
		// 	action: 'open.datasource.table.Data.getData',
		// 	params: ['code', PROPERTIES, {
		// 		filter: [{
		// 			'text': id,
		// 			'code': 'ARCIMEDES_ROW_ID',
		// 			'type': 'exact',
		// 		}],
		// 	}],
		// let token = localStorage.getItem('authToken');
		// 	this.props.client.query({ query: GET_PROPERTY_DATA, variables: { arcimedesRowId: id },
		// 		fetchPolicy: "no-cache",
		// 		context: {
		// 		  headers: {
		// 			authorization: `Bearer ${token}`,
		// 		  },
		// 		} 
		// })
		fetchData(GET_PROPERTY_DATA,{ arcimedesRowId: id })
		.then(res => {
			if (res && res.data && res.data.getpropertyQuery) {
				this.setState({
					property: res.data.getpropertyQuery,
					error: null,
				});
			} else {
				this.setState({
					property: false,
					error: res.message ? res.message : 'Unidentified Error',
				})
			}
		});
	}

	render() {
		const p = this.state.property;
		const zoom = this.props.location.query && this.props.location.query.zoom ? parseInt(this.props.location.query.zoom) : 8;
		const mapTypeId = this.props.location.query && this.props.location.query.mapTypeId ? this.props.location.query.mapTypeId : 'roadmap';

		if (p === null) {
			return null;
		} else if (p.latitude && p.longitude) {
			return (
				// <ApolloConsumer>
				// {
				// 	client => {
				// 		if (!this.client) {
				// 			this.client = client;
				// 		}
				// 		return (
				<ListMap listings={[p]} latitude={p.latitude} longitude={p.longitude} zoom={zoom} mapTypeId={mapTypeId}/>
		// 	)
        // }
        // }
        // </ApolloConsumer>
			);
		} else {
			return (
				<div>Address is either missing, failed to geocode, or has yet to be geocoded.</div>
			);
		}
	}
}
